import React from 'react'
import {Link} from 'react-router-dom'
import AOS from 'aos'
import {SideScroll}from '../components/SideScroll'
import {ShowApps} from '../components/ShowApps'
import Solutions from '../components/Solutions'
import ContentSilder from '../components/ContentSilder'
import HubblerStudio from '../components/HubblerStudio'
import Footer from '../components/Footer'
import hrImage from '../images/how-it-works/group-copy-2.png'
import {data,appsData,companyLogos} from '../data/webData'
import CountUp, { startAnimation } from 'react-countup';
import dividerLineBlue from '../images/divider-line-03.svg'
import dividerLinePink from '../images/group-76-copy.svg'
import AliceCarousel from 'react-alice-carousel';
import Typing from '../components/common/Typing'
import CompanyLogos,{imageList} from '../components/CompanyLogos'


const responsive = {
    0: {
        items: 2
    },
    320: {
        items: 2
    },
    550:{
        items: 3
    },
    768: {
        items: 4
    },
    1024: {
        items: 4
    },
    1260: {
        items: 5
    },
    1460: {
        items: 5
    },
    3000:{
        items:5
    }
};

export class LogoSliderComponent extends React.Component{
    galleryItems(){
        return (imageList.map(item=><li><img src={item}/></li>))
    }
    render(){
        return <div className={'company-logos'}>
            <AliceCarousel autoPlay={true} autoPlayInterval={2500} duration={400} responsive={responsive}  items={this.galleryItems()}/>
        </div>
    }
}

class IndexPage extends React.Component{
    constructor(){
        super()
        this.state = {
            previewItem:2,
            countAnimation:true,
            width:'',
            height:''
        }
    }
    componentDidMount(){
        let self = this;
        this.aos = AOS;
        this.aos.init({
            duration: 1500,
            once: true,
        });
        window.addEventListener('scroll', (event)=>{
            if(document.getElementById('hubber-count')){
                const elementOffset = document.getElementById('hubber-count').offsetTop
                const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if(this.state.countAnimation){
                    if(elementOffset < (scrollPosition + 600)){
                        startAnimation(self.myCountUp)
                        startAnimation(self.customApps)
                        startAnimation(self.usersOnboard)
                        self.setState({
                            countAnimation:false
                        })
                    }
                }
            }
        })
    }
    componentDidUpdate() {
        this.aos.refresh();
    }
    previewItemsDetails(id){
        this.setState({
            previewItem:id
        })
    }
    galleryItems(){
        return imageList.map(item=><li><img src={item}/></li>)
    }
    render(){
        const previewDetails = data.find(item=>item.id == this.state.previewItem)
        return <div className={'products'}>
            <div className={'start-mobile'}>
                <div className={'start-content'} id={'product'}>
                    <div className={'platform'}>
                        <div className={'platform-sub'}>
                            {/*
                      <div className={'introducing-hubbler'} data-aos="fade-up" data-aos-offset="150">Introducing hubbler</div>
*/}

                            {/*  <AliceCarousel autoPlay={true} autoPlayInterval={10000} duration={500} responsive={responsive}>
                          <div>
                              <p className={'platform-organisation'} data-aos="fade-up" data-aos-offset="150">Now, brew your apps faster than your coffee</p>
                              <p className={'platform-discription'} data-aos="fade-up" data-aos-offset="150">hubbler's AppStudio brings DIY to business processes. With a powerful set of building blocks, our app studio lets you design, build and deploy a wide variety of apps in minutes.</p>
                          </div>
                          <div>
                          <p className={'platform-organisation'} data-aos="fade-up" data-aos-offset="150">A platform that brings everyone closer </p>
                          <p className={'platform-discription'} data-aos="fade-up" data-aos-offset="150">hubbler believes in the power of an engaged and motivated workforce. From rewards to celebrations to milestones to collaborations to announcements to policies - hubbler has it all. </p>
                      </div>
                          <div>
                          <p className={'platform-organisation'} data-aos="fade-up" data-aos-offset="150">Don’t let those morning reports bog you down </p>
                          <p className={'platform-discription'} data-aos="fade-up" data-aos-offset="150">hubbler changes the way you look at the data. It lets you take control. You decide what, when and how you want to see, As it happens.</p>
                      </div>
                          <div>
                              <p className={'platform-organisation'} data-aos="fade-up" data-aos-offset="150">Do not change the way you work - make the platform work for you </p>
                              <p className={'platform-discription'} data-aos="fade-up" data-aos-offset="150">hubbler provides a liberating space where you can take the steering wheel and create your own specific solutions. You build what you want and analyse what you want.</p>
                          </div>
                      </AliceCarousel>*/}
                            <div className={'head-info'} data-aos="fade-up">
                                {/*We help <Typing dataPeriod="2000" dataType={[ "enterprises", "teams","people"]}/><br/>*/}
                                {/*redefine their work*/}
                                Turn your idea into an app<br/>in record time
                            </div>
                            <p data-aos="fade-up">
                                Hubler’s no-code, DIY platform lets enterprises build powerful apps to automate their unique business processes.
                                Build on iOS, Android and Web simultaneously and give your team software that fits like a glove.
                            </p>
                            {/*
                      <button className={'bt bt-blue explore-more'} data-aos="fade-up" data-aos-offset="150">Know How</button>
*/}
                        </div>
                        <div className={'socail-media'}>
                            <a className={'apple'} href="https://itunes.apple.com/in/app/hubbler/id1190887110?mt=8" target="_blank"></a>
                            <a className={'google'} href="https://play.google.com/store/apps/details?id=mobi.hubbler.app" target="_blank"></a>
                        </div>
                    </div>
                </div>
            </div>
            <LogoSliderComponent/>


            {/*  <div className={'what-unique'} data-aos="fade-up"><label>What makes us <span>unique</span></label></div>
          <div className={'what-unique-container'}>
              <div className={'what-unique-container-sub'}>
                  <div className={'unique-cls plug-and-play'} data-aos="zoom-in-right">
                      <div className={'logo'}></div>
                      <div className={'head'}>Plug and play</div>
                      <p>Apps as and when you need them, as you need them</p>
                  </div>
                  <div className={'unique-cls  no-code'} data-aos="zoom-in-up">
                      <div className={'logo'}></div>
                      <div className={'head'}>No Code</div>
                      <p>Create a custom app with no code with our in-built tool</p>
                  </div>
                  <div className={'unique-cls  compatible'} data-aos="zoom-in-left">
                      <div className={'logo'}></div>
                      <div className={'head'}>Compatible</div>
                      <p>With most legacy systems so that you don’t have to migrate</p>
                  </div>
              </div>
          </div>*/}

            <div className={'find-apps-container'}>
                <div className={'solutions-container'} id='marketPlace'>
                    {/* <div className={'solutions-text'} data-aos="fade-up">
                     <div className={'text'}>Solutions that <span>stick.</span> </div>
                     <p>Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Donec sed odio dui.</p>
                  </div>
                  <div className={'text-hub mobile'}>Hubler bring all this together
                      on one single screen </div>*/}
                    <div className={'solutions-details'}>
                        <Solutions/>
                    </div>
                </div>

                <div className={'find-apps-text'} data-aos="fade-up">
                    <div className={'text'}>Or choose from our fully customisable, ready-to-use apps</div>
                    <p>Pick and choose apps that suit your team’s workflows. Modify them as per your team’s needs.
                        Onboard your team and start working in record time.</p>
                </div>
                <div className={'find-apps-list-container'}>
                    <ShowApps appsData={appsData}/>
                </div>



{/*                <div className={'ecosystem-details-container'}>*/}
{/*                    <div className={'ecosystem-of-solutions-container'}>*/}
{/*                        <div className={'ecosystem-of-solutions'} data-aos="fade-up">*/}
{/*                            <div className={'ecosystem-of-solutions-sub'}>*/}
{/*                                /!**/}
{/*                     <img src={dividerLinePink}/>*/}
{/**!/*/}
{/*                                <div className={'head'}>Solutions to your daily challenges  </div>*/}
{/*                                /!**/}
{/*                     <div className={'head-sub'}>for the relevant Questions</div>*/}
{/**!/*/}
{/*                                <p>We’re throwing the power back at the enterprise; you can make any process, need, or data collaboration faster, intuitive, and easier with Hubler.</p>*/}

{/*                                /!**/}
{/*                     <div className={'sign-up-now'}>Sign up now</div>*/}
{/**!/*/}

{/*                            </div>*/}
{/*                        </div>*/}
{/*                    </div>*/}
{/*                    <div className={'discover-container'}>*/}
{/*                        <SideScroll previewItemsDetails={this.previewItemsDetails.bind(this)} data={data} width={this.state.width}/>*/}
{/*                    </div>*/}
{/*                </div>*/}

                <div className={'enhance-your-productivity'}>
                    <div className={'enhance-your-productivity-sub'}>
                        <div className={'style-img'}>
                            <div className={'style-img-sub'} data-aos="fade-up"></div>
                        </div>
                        <div className={'discription'}>
                            <div className={'title'} data-aos="fade-up">Stop using software that was built for someone else</div>
                            <p className={'parp'} data-aos="fade-up">Customize everything about your app from start to finish. Give your team an application that’s perfect for their business process. No more compromises,
                                adjustments and workarounds. Get software that’s perfect for the job and easy to use.</p>
                        </div>
                    </div>
                </div>

                <div className={'solutions-together-container'}>
                    {/*  <div className={'solutions-together-text'} data-aos="fade-up">
                      <div className={'text'}>Solutions that fit to <span> tie it all together</span> </div>
                  </div>*/}
                    <div className={'solutions-together-details'}>
                        <div className={'preview-img web'}>
                            <div className={'show-img'} data-aos="zoom-in"></div>
                        </div>
                        <div className={'details'}>
                            <div className={'title'} data-aos="fade-up">Integrate, Automate & Accelerate</div>
                            <div className={'preview-img mobile'}>
                                <div className={'show-img'} data-aos="zoom-in"></div>
                            </div>
                            <p data-aos="fade-up">We get it: you can't stop using your legacy systems.
                                They hold all your business data. We’re talking about your ERP, CRM, accounting systems,
                                and other legacy applications. Good news! Hubler can integrate with all of them seamlessly.
                                And automate a variety of manual, repetitive tasks within them, allowing you to speed up process cycles
                                and register incredible cost savings.
                            </p>

                            {/*
                         <Link className={'ask-for-a-demo'} data-aos="fade-up" to="demo">Ask for a demo</Link>
*/}

                        </div>
                    </div>
                </div>

                {/* <div className={'choose-app'}>
                  <div className={'choose-app-sub'}>
                      <div className={'title'} data-aos="fade-up">200+ Apps to choose from for the perfect fit</div>
                      <div className={'details'} data-aos="fade-up">
                          <div>
                              Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Donec sed odio dui.
                          </div>
                          <div>
                              <button className={'explore-market'}>Explore Market place</button>
                          </div>
                  </div>
              </div>
              </div>*/}
                {/*  <div className={'hubbler-studio-container'} id='about'>
                    <HubblerStudio/>
              </div>*/}
                {/*  <div className={'number-of-users-container'} id={'hubber-count'}>
                  <div className={'number-of-user-sub'}>
                      <div className={'companies number-of'} data-aos="zoom-in-up">
                          <div className={'number-cls'}>
                              <CountUp className="CountUp" start={0} end={55} duration={3} ref={(countUp) => {
                                  this.myCountUp = countUp;
                              }}/>
                          </div>
                          <div className={'name'}>
                              Companies
                          </div>
                      </div>
                      <div className={'custom-apps number-of'} data-aos="zoom-in-up">
                          <div className={'number-cls'}>
                              <CountUp className="CountUp" start={0} end={250} duration={2} ref={(countUp) => {
                                  this.customApps = countUp;
                              }}/>
                          </div>
                          <div className={'name'}>
                              Custom Apps
                          </div>
                      </div>
                      <div className={'users-onboard number-of'} data-aos="zoom-in-up">
                          <div className={'number-cls'}>
                              <CountUp className="CountUp" start={0} end={2000} duration={1} ref={(countUp) => {
                                  this.usersOnboard = countUp;
                              }}/>+
                          </div>
                          <div className={'name'}>
                              Users Onboard
                          </div>
                      </div>
                  </div>
              </div>*/}
            </div>

            <div className={'what-unique'} data-aos="fade-up">
                <label>What makes us unique{/*<span>unique</span>*/}</label>
                {/*
                  <div className={'para'}>Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Donec sed odio dui.</div>
*/}
            </div>

            <div className={'what-unique-container'}>
                <div className={'what-unique-container-sub'}>
                    <div className={'unique-cls plug-and-play'} data-aos="zoom-in-up">
                        <div className={'logo'}></div>
                        <div className={'dis'}>
                            <div className={'head'}>Plug and play</div>
                            <p>200+ apps to choose from.  As and when you need them</p>
                        </div>
                    </div>
                    <div className={'unique-cls  no-code'} data-aos="zoom-in-up">
                        <div className={'logo'}></div>
                        <div className={'dis'}>
                            <div className={'head'}>No Code, All DIY</div>
                            <p>Digitise any process as you go</p>
                        </div>
                    </div>
                    <div className={'unique-cls  anytime-anywhere'} data-aos="zoom-in-up">
                        <div className={'logo'}></div>
                        <div className={'dis'}>
                            <div className={'head'}>Anytime Anywhere</div>
                            <p>Web, Mobile, Online, Offline, Everything Covered!</p>
                        </div>

                    </div>
                    <div className={'unique-cls  compatible'} data-aos="zoom-in-up">
                        <div className={'logo'}></div>
                        <div className={'dis'}>
                            <div className={'head'}>Compatible</div>
                            <p>Integrates seamlessly with ERPs, Payment Gateways, Legacy Systems, etc</p>
                        </div>
                    </div>
                </div>
            </div>


            <div className={'content-slider-container'}>
                <ContentSilder/>
            </div>
            {/*<div className={'help-container'}>
                <div className={'help-container-sub'} data-aos="fade-up" data-aos-offset="100">
                    <div className={'text'}>
                        We would love to  <br/>
                        hear from you!
                    </div>
                    <div className={'btn-cls'}>

                        <a className={'bt'}>Call us</a>
                    </div>
                  </div>
          </div>*/}
            <div>

            </div>
        </div>
    }
}



export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js